var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAnalise01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    d: "M18,35.5c-2.2,0-4.5-0.4-6.5-1.3C9.7,36,7,36,5.2,34.3c-1.7-1.7-1.7-4.5,0-6.2c1.7-1.7,4.5-1.7,6.2,0 c0.8,0.8,1.3,1.8,1.3,3c3.5,1.4,7.3,1.4,10.7-0.1c3.4-1.4,6-4.1,7.4-7.4c0.7-1.7,1.1-3.6,1.1-5.5h3.5C35.5,27.6,27.7,35.5,18,35.5 C18.1,35.5,18,35.5,18,35.5z M4,18H0.5c0-7,4.2-13.4,10.7-16.1c4.3-1.8,9.1-1.8,13.4-0.1C26.3,0,29,0,30.7,1.8s1.7,4.5,0,6.2 c-0.8,0.8-1.9,1.3-3.1,1.3c-2.4,0-4.3-1.9-4.4-4.2C19.8,3.6,16,3.6,12.5,5.1c-3.4,1.4-6,4.1-7.4,7.4C4.4,14.2,4,16.1,4,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M18,25.9c-4.4,0-7.9-3.6-7.9-7.9S13.6,10,18,10S26,13.6,26,18C25.9,22.4,22.4,25.9,18,25.9z M18,13.5 c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4C22.4,15.5,20.5,13.5,18,13.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAnalise01);
export default __webpack_public_path__ + "static/media/ico-analise-01.63c5724c727757141b2ab8ae3dc4417f.svg";
export { ForwardRef as ReactComponent };